import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      // main: '#39363f',
      main: '#31322c',
      // main: '#625656',
      // main: '#5c4f56',
      // main: '#141514',
      // main: '#000010',
      // main: '#170814',
      // main: '#a61b29', // 殷红
      // main: '#82333f', // 殷红
      // main: '#c21f30', // 枫叶红
      // main: '#d42517', // 鹤顶
    },
    background: {
      default: '#fafafa',
    },
  },
});

export default theme;
